import gql from 'graphql-tag';

export const Device = gql`
  fragment Device on Device {
    _id
    name
    active
    os
    type
  }
`;

export const Log = gql`
  fragment Log on Log {
    createdAtStr
    type
    deviceId
  }
`;

export const SimpleUser = gql`
  fragment SimpleUser on User {
    _id
    role
    name
    loginName
    active
  }
`;

export const User = gql`
  fragment User on User {
    ...SimpleUser
    loginToken
    clients {
      _id
    }
    employees {
      _id
    }
  }
  ${SimpleUser}
`;

export const LogUser = gql`
  fragment LogUser on User {
    ...User
    devices {
      ...Device
    }
    logs {
      ...Log
    }
  }
  ${User}
  ${Device}
  ${Log}
`;

export const ArtCollectionPermission = gql`
  fragment ArtCollectionPermission on ArtCollectionPermission {
    _id
    viewer {
      name
    }
    published
  }
`;

export const SimpleArtCollection = gql`
  fragment SimpleArtCollection on ArtCollection {
    _id
    name
    owner {
      ...SimpleUser
    }
  }
  ${SimpleUser}
`;

export const ArtCollection = gql`
  fragment ArtCollection on ArtCollection {
    ...SimpleArtCollection
    directoryName
    owner {
      _id
      name
    }
    published
    artCollectionPermissions {
      ...ArtCollectionPermission
    }
  }
  ${SimpleArtCollection}
  ${ArtCollectionPermission}
`;



// WEBPACK FOOTER //
// ./src/qql-shared/fragments.js